<template>
  <fragment>
    <div class="modal-title">
      {{ template.name }}
      <i class="modal-close-button" @click="$emit('close')"></i>
    </div>

    <div class="modal-body">
      <div v-html="template.full_description"></div>
      <div class="columns is-centered">
        <div class="is-6" >
          <button class="button is-primary is-medium" @click="checkout()">
            Purchase Template
          </button>
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
export default {
  name: "FinModelDetails",
  props: ['template'],
  methods: {
    checkout() {
      this.$router.push({name: "checkout", params: {priceId: this.template.plan}, query: {templateId: this.template.id}});
      this.$emit('close')
    },
  }
}
</script>

<style scoped>
.modal-title {
  background-image: url(../../../images/investment.svg);
}
</style>